module.exports = __webpack_public_path__ + "img/not-direct.61570c74.png";